<div class="body_container">
  <h4>Job List</h4>
  <table class="table  main-panel-table" style="white-space: nowrap;">
    <thead>
      <tr class="table-list-head">
        <th scope="col" resizable>#</th>
        <th scope="col" resizable>Deployment</th>
        <th scope="col" resizable>Scheduler</th>
        <th scope="col" resizable>Infrastructure</th>
        <th scope="col" resizable>No. of Jobs</th>
      </tr>
    </thead>
    <tbody *ngIf="!dataEmpty">
      <tr class="table-list-row" *ngFor="let dep of deployments |  paginate: { itemsPerPage: 10, currentPage: p }; let i = index"
          style="cursor: pointer"
          (click)="redirectTo(dep)">
        <td scope="row" *ngIf="p == 1">{{ i + 1 }}</td>
        <td scope="row" *ngIf="p != 1">
          {{ (p - 1) * 10 + (i + 1) }}
        </td>
        <td class="impListName">
          {{ dep.name }}
        </td>
        <td>{{ dep.numOfComputeNodes == -1 && dep.headNodeIp == "NA" ?  'NA' : dep.scheduler }}</td>
        <td>{{ dep.cloud }}</td>
        <td>{{ dep.noOfJobs }}</td>
      </tr>
    </tbody>
  </table>
  <pagination-controls *ngIf="deployments"
                       class="my-pagination ms-auto"
                       (pageChange)="p = $event">
  </pagination-controls>
  <p *ngIf="dataEmpty" style="text-align: center; margin-top: 5%">
    No Deployment Available.
  </p>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="default"
               zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
